import { useLayoutEffect, useMemo, useState } from 'react'

export default function useHeight<T extends HTMLElement>(): [React.Ref<T> | undefined, number] {
    const [element, ref] = useState<T | null>(null)
    const [height, setHeight] = useState(0)
    
    const observer = useMemo(() => {
        return new window.ResizeObserver(() => setHeight(element?.offsetHeight || 0))
    }, [element])
      
    useLayoutEffect(() => {
        if (!element) return
        observer.observe(element)
        return () => observer.disconnect()
    }, [element, observer])

    return [ref, height];
}